import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const LoveItRegular = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='currentColor'
    stroke='currentColor'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='m12 21.844-9.588-10a5.672 5.672 0 0 1-1.063-6.551h0a5.673 5.673 0 0 1 9.085-1.474L12 5.384l1.566-1.565a5.673 5.673 0 0 1 9.085 1.474h0a5.673 5.673 0 0 1-1.062 6.548Z'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
    />
  </svg>
)

export { LoveItRegular }
